// @ts-ignore
import React, { memo } from 'react';
import { BemMethod, createBem } from '@om-fe/utils';
import { DisciplineLiveStatus } from '@om-fe/models';
import { MixedGroupedTournamentModel } from '../../mixed-grouped.types';
import { MatchListItemLayout } from '@om-fe/core/components/match-list/utils/match-list.constants';
import { DisciplineRouteType } from '@om-fe/core/components/discipline-anchor/discipline-route.utils';
import { UseSimpleStore, useSimpleStoreItem } from '@om-fe/store';
import { DEFAULT_LIMIT_NUMBER_OF_EVENTS } from '../../../../common/constants';
import { MAIN_MARKET_MIN_LIMIT } from '@om-fe/core/components/match-list/utils/match-list.constants';
import getConfig, { OMFE2ConfigModel } from '@om-fe/core/utils/config';
import TournamentMatchList from '../../../../components/match-list/containers/tournament-match-list/tournament-match-list';
import { FilteredMarketGroupsOverview } from '../../../../components/match-list/utils/match-list-models';
import { PlatformTypes } from '@om-fe/utils';

export interface MixedGroupedMatchListItemProps {
    readonly useStore: UseSimpleStore<MixedGroupedTournamentModel>;
    readonly id: string;
    readonly sportPageType: DisciplineRouteType;
    readonly mainMarketsLimit?: number;
    readonly marketSelector?: boolean;
    readonly groupOverview?: string;
    readonly isLoading?: boolean;
    readonly showMarketSelectorHeader?: boolean;
    readonly selectGroupsOverview?: (item: string) => void;
    readonly filteredMarketGroupsOverviewList: string[];
    readonly filteredMarketGroupsOverview?: Record<string, FilteredMarketGroupsOverview>;
    readonly isHasDrawer?: boolean;
    readonly deviceType?: PlatformTypes;
}

const bem: BemMethod = createBem('MixedGroupedMatchListItem');

export const MixedGroupedMatchListItem = memo((
    {
        useStore,
        id,
        mainMarketsLimit,
        marketSelector,
        groupOverview,
        isLoading,
        selectGroupsOverview,
        filteredMarketGroupsOverview,
        filteredMarketGroupsOverviewList,
        deviceType,
        isHasDrawer,
        showMarketSelectorHeader,
    }: MixedGroupedMatchListItemProps,
) => {
    const tournament: MixedGroupedTournamentModel = useSimpleStoreItem<MixedGroupedTournamentModel>(useStore, id);

    const {
        numberOfLiveEvents,
        numberOfUpcomingMatches,
    } = tournament;

    const hasLiveEvents: boolean = !!numberOfLiveEvents;
    const hasUpcomingEvents: boolean = !!numberOfUpcomingMatches;

    if (!hasLiveEvents && !hasUpcomingEvents) {
        return null;
    }
    const config: OMFE2ConfigModel = getConfig();
    const matchListLayout: undefined | MatchListItemLayout = config.matchListConfig?.commonConfig?.matchListItemLayout;

    return (
        <div className={bem({
            modifiers: { NoLiveEvents: !hasLiveEvents, NoUpcomingEvents: !hasUpcomingEvents },
        })}>
            <div className={bem('Content')}>
                <div className={bem('Live')}>
                    {!isLoading && (marketSelector && showMarketSelectorHeader && filteredMarketGroupsOverviewList.length
                        ? <TournamentMatchList
                            instanceId={`mixed-grouped-match-list-item-${id}-Live`}
                            tournamentId={id}
                            liveStatus={DisciplineLiveStatus.BOTH}
                            itemLayout={matchListLayout}
                            limitNumberOfEvents={DEFAULT_LIMIT_NUMBER_OF_EVENTS}
                            mainMarketsLimit={mainMarketsLimit ?? MAIN_MARKET_MIN_LIMIT}
                            hasMarketSelector={marketSelector}
                            marketsHeaderOptions={config.marketsHeaderOptions}
                            showMatchListHeader={false}
                            showMarketInMatchListGroupHeader={true}
                            groupOverview={groupOverview}
                            selectGroupsOverview={selectGroupsOverview}
                            filteredMarketGroupsOverview={filteredMarketGroupsOverview}
                            filteredMarketGroupsOverviewList={filteredMarketGroupsOverviewList}
                            isHasDrawer={isHasDrawer}
                            deviceType={deviceType}
                            preventRedirect={true}
                        />
                        : <TournamentMatchList
                            instanceId={`mixed-grouped-match-list-item-${id}-Live`}
                            tournamentId={id}
                            liveStatus={DisciplineLiveStatus.BOTH}
                            itemLayout={matchListLayout}
                            limitNumberOfEvents={DEFAULT_LIMIT_NUMBER_OF_EVENTS}
                            mainMarketsLimit={mainMarketsLimit ?? MAIN_MARKET_MIN_LIMIT}
                            hasMarketSelector={marketSelector}
                            marketsHeaderOptions={config.marketsHeaderOptions}
                            showMatchListHeader={false}
                            showMarketInMatchListGroupHeader={true}
                            groupOverview={groupOverview}
                            preventRedirect={true}
                        />)
                    }
                </div>
            </div>
        </div>
    );
});